import { AsyncThunkPayloadCreator, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpStatusCode } from 'axios';
import { setHasUserInsufficientPermissions } from './user/userActions';
import { IUserState } from './user/types';

const createAsyncThunkWithCustomErrorHandling = <Returned, ThunkArg>(
  type: string,
  payloadCreator: AsyncThunkPayloadCreator<Returned, ThunkArg>,
) =>
  createAsyncThunk(type, async (arg: ThunkArg, thunkAPI) => {
    try {
      return await payloadCreator(arg, thunkAPI);
    } catch (error: any) {
      const state = thunkAPI.getState() as { user: IUserState };
      const { userId } = state.user.userData.user;

      if (error.cause === HttpStatusCode.Forbidden || (error.cause === HttpStatusCode.InternalServerError && !userId)) {
        thunkAPI.dispatch(setHasUserInsufficientPermissions(true));
      }

      return thunkAPI.rejectWithValue({ cause: error.cause });
    }
  });

export { createAsyncThunkWithCustomErrorHandling };
